
import { Component } from 'react'
import  AddCollectionData  from './AddCollectionData';

class ViewUserCollection extends Component {

    render() {
        return (
            <>
                <AddCollectionData/>
            </>
        )
    }
}

export default ViewUserCollection
